import environment from 'modules/core/constants/environment';

export const isSandbox = () => ['sandbox', 'local'].includes(environment.ENV);

export const getCurrentOrigin = () => {
	const { protocol, hostname, port } = window.location;
	return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
};

export const getFinancialInstitutionDomain = () => {
	const configured = environment.FINANCIAL_INSTITUTION_DOMAIN?.trim();
	return configured || getCurrentOrigin();
};
